module.exports = __webpack_public_path__ + "img/zimzum.bc09808a.png";